<template>
  <TableBodyRow
    :thead="thead"
    class="breakdownrow gw_table_body_row_hoverable"
    :class="[
      { breakdownrow_scaled: isScaled },
      { breakdownrow_dimmed: isDimmed && !isScaled },
      item.table_tr_css_class,
    ]"
  >
    <TableBodyCell
      thKey="category"
      class="gw_table_body_cell_sticky"
    >
      <div
        class="truncate"
        :title="$t(`browse.filter_rules.${item.name}`)"
      >
        {{ $t(`browse.filter_rules.${item.name}`) }}
      </div>
    </TableBodyCell>
    <TableBodyCell
      thKey="breakdown_performed"
      style="--padding-td: 0"
    >
      <div
        v-if="item.solution.length === 1"
        class="position-absolute f-center h-100 w-100 z-index_4"
      >
        {{ numFixedUnit(item.solution[0].total_frequency * 100, 'strategy') }}
      </div>
      <div
        class="graph-horizontal_full graph-horizontal graph-horizontal_transparent graph-horizontal_overflow graph-actions-breakdown"
        :data-tst="`breakdown_table_chart_${item.name}`"
      >
        <div
          v-for="(action, idx) in item.solution"
          :key="`${action.code}_${idx}`"
          :class="[action.css_class, actionDimmed(action)]"
          class="graph-horizontal_item graph-actions-breakdown_item csst"
          :style="`width: ${action.total_frequency * 100}%; ${
            useHex ? `background:${action.hex}` : ''
          }`"
          @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'bottom' })"
        >
          <div
            class="csst_content f-center text-normal"
            style="position: fixed"
          >
            <div class="circle-bullet circle-bullet_large"></div>
            <div class="clr-white ml-2">
              {{ action.display_name || $t(`browse.${action.group_display_name}`) }}
              <span
                class="pl-1"
                v-html="getBetHtml({ showBetsIn, a: action })"
              ></span>
            </div>
            <div class="pl-3 clr-white">
              {{ numFixedUnit(action.total_frequency * 100, 'strategy') }}%
            </div>
          </div>
        </div>
      </div>
    </TableBodyCell>
    <TableBodyCell thKey="breakdown_range">
      {{ numFixedUnit(item.totalRange * 100, 'range_percent') }}
    </TableBodyCell>
    <TableBodyCell thKey="combos">
      {{ numFixedUnit(item.totalCombos, 'combos') }}
    </TableBodyCell>
    <TableBodyCell
      thKey="breakdown_summary"
      style="--padding-td: 0; --z-index-td-hover: 4"
      class="breakdownrow_hands_cell"
      :class="{ 'no-events': !item.summary.combos.length }"
    >
      <StudyAllHandsHero
        class="breakdownrow_hands"
        style="
          --height: var(--hands-height);
          width: var(--hands-width);
          --radius: var(--hands-radius);
        "
        :tstPrefix="item.name"
        :activeHandsIds="activeHandsIds || []"
        :customCombos="item.summary.combos"
        :useHex="useHex"
        :isPinned="isPinned"
        :viewProps="viewProps"
        @combo:click="val => $emit('combo:click', val)"
        @combo:mouseenter="val => $emit('combo:mouseenter', val)"
        @combo:mouseleave="val => $emit('combo:mouseleave', val)"
        @allhands:mouseenter="val => $emit('allhands:mouseenter', val)"
      />
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'
import StudyAllHandsHero from '@/components/Study/StudyAllHandsHero'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'BreakdownTableV2Row',

  components: {
    TableBodyRow,
    TableBodyCell,
    StudyAllHandsHero,
  },
  mixins: [table_mix, float_mix],
  props: {
    item: Object,
    index: Number,
    thead: Object,
    useHex: Boolean,
    actionHighlighted: Object,
    activeHandsIds: Array,
    showBetsIn: String,
    isPinned: Boolean,
    isScaled: Boolean,
    isDimmed: Boolean,
    viewProps: Object,
  },
  emits: ['combo:click', 'combo:mouseenter', 'combo:mouseleave', 'allhands:mouseenter'],
  data() {
    return {}
  },
  methods: {
    actionDimmed(ag) {
      // console.log(ag, this.actionHighlighted)
      if (!this.actionHighlighted) {
        return ''
      }
      const match = this.actionHighlighted.group_display_name
        ? this.actionHighlighted.group_display_name === ag.group_display_name
        : this.actionHighlighted.code === ag.code
      return match ? '' : 'graph-horizontal_item_dimmed'
    },
  },
}
</script>

<style lang="scss" scoped>
.tr-divider-top {
  border-top: 4px solid var(--clr-black-2);
}

.breakdownrow_hands_maximized {
  --hands-height: var(--hands-height-maximized);
  --hands-width: var(--hands-width-maximized);
  --hands-radius: 8px 0px 0px 8px;
  --hands-shadow: var(--menu-shadow2);

  position: absolute;
  top: var(--hands-top-maximized);
  right: 0;
  z-index: 4;
  &:after {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: -2rem;
    z-index: -1;
  }
}

.breakdownrow {
  --hands-height: 100%;
  --hands-width: 100%;
  --hands-top-maximized: -62.5%;
  --hands-height-maximized: 225%;
  --hands-width-maximized: clamp(100%, 250%, 42rem);
  &_dimmed {
    &:after {
      content: '';
      position: absolute;
      background: rgb(0, 0, 0, 0.5);
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 1;
    }
  }
  &_scaled {
    z-index: 4;
    .breakdownrow_hands_cell {
      z-index: 4;
    }
    &:after {
      display: none;
    }
    .breakdownrow_hands {
      @extend .breakdownrow_hands_maximized;
    }
  }
}
@media (hover: hover) and (pointer: fine) {
  .breakdownrow {
    &:hover {
      &:after {
        display: none;
      }
    }
    .breakdownrow_hands {
      &:hover {
        --hands-height: var(--hands-height-maximized);
        --hands-width: var(--hands-width-maximized);
        --hands-radius: 8px 0px 0px 8px;
        --hands-shadow: var(--menu-shadow2);
        position: absolute;
        top: var(--hands-top-maximized);
        right: 0;
        z-index: 4;
        &:after {
          content: '';
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          left: -2rem;
          z-index: -1;
        }
      }
    }
  }
}
</style>
